/**
 * Deals with options from chip content model
 */
export class ChipContentOption {
  /**
   * @constructor
   */
  constructor(public key: string, public text: string) {}
}
